<template>
  <div>
    <div class="not-print">
      <div class="not-print"></div>
      <br />
    </div>

    <div class="row not-print" style="margin: 1px">
      <div class="col-md-12 ml-1">
        <collapse-of-the-order-filter
          ref="CollapseOfTheOrderFilter"
          :buttonPrint="true"
          v-model="searchForm"
          @filter="getOrders()"
          @print="print()"
        />
      </div>
    </div>

    <div class="row" style="margin: 3px">
      <div class="col">
        <b-card title="Relatório  de vendas">
          <div class="row">
            <div class="col">
              {{  orders.length }}
              registros encontrados!
            </div>
          </div>
          <div class="row">
            <div class="col" v-if="searchForm.saved_at_start">
              <span>Período de consulta : </span>
              {{ searchForm.saved_at_start | dateBr }}

              <span v-if="searchForm.saved_at_end">
                até {{ searchForm.saved_at_end | dateBr }}
              </span>
            </div>
          </div>

          <br />
          <div class="row justify-content-around">
            <div>
              <span class="font-weight-bold">Dinheiro: </span>
              {{ ordersData.money.sum_value | decimal }}
            </div>
            <div>
              <span class="font-weight-bold">Cheque: </span>
              {{ ordersData.check.sum_value | decimal }}
            </div>

            <div>
              <span class="font-weight-bold">Crediário: </span>
              {{ ordersData.installment.sum_value | decimal }}
            </div>

            <div>
              <span class="font-weight-bold">C. Credito: </span>
              {{ ordersData.creditCard.sum_value | decimal }}
            </div>
            <div>
              <span class="font-weight-bold">C. Débito: </span>
              {{ ordersData.debtCard.sum_value | decimal }}
            </div>

            <div>
              <span class="font-weight-bold">Depósito Bancário: </span>
              {{ ordersData.bank_deposit.sum_value | decimal }}
            </div>
            <div>
              <span class="font-weight-bold">PIX: </span>
              {{ ordersData.pix.sum_value | decimal }}
            </div>
            <div>
              <span class="font-weight-bold">Outros: </span>
              {{ ordersData.outers.sum_value | decimal }}
            </div>
            <div>
              <span class="font-weight-bold">Carteira Digital: </span>
              {{ ordersData.digitalWallet.sum_value | decimal }}
            </div>
          </div>
          <br />
          <div class="row justify-content-between">
            <div class="col">
              <span class="font-weight-bold">Total: </span>
              {{ ordersData.ordersTotal.sum_value | decimal }}
            </div>
            <div v-if="this.$acl.isAdmin()" class="col">
              <span class="font-weight-bold">Margem Total: </span>
              {{ ordersData.profit.sum_value | decimal }}
            </div>

            <div class="col text-right">
              <small >Consulta Realizada :
              {{ date | dateTimeBr }}</small>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row" style="margin: 3px">
      <div class="col">
        <b-table small :items="orders" :fields="fields">
          <template #cell(client_id)="data">
            <span v-if="data.item.unidentified_client">
              ---
            </span>
            <span v-else>
              {{ data.item.customer.name }}
            </span>
          </template>
          <template #cell(salesman_id)="data">
            <span v-if="data.item.salesman_id == null">
                ---
            </span>
            <span v-else>
              {{ data.item.salesman.name }}
            </span>
          </template>
          <template #cell(ordered_at)="data">
            {{ data.item.ordered_at | dateBr }}
          </template>
          <template #cell(net_total)="data">
            {{ data.item.net_total | decimal }}
          </template>
          <template #cell(profit)="data">
            {{ data.item.profit | decimal }}
          </template>
          <template #cell(payment_method)="data">
            <div v-for="(row, index) in data.item.order_bill" :key="index">
              {{ payment_method[row.payment_method].text }}
              {{ row.value | decimal }}
            </div>
          </template>
          <template #cell(status)="data">
            <span
              :class="['badge', 'text-white', status[data.item.status].class]"
              style="line-height: 1.2"
              >{{ status[data.item.status].text }}</span
            >
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import CollapseOfTheOrderFilter from "@/components/Filter/CollapseOfTheOrderFilter.vue";
import moment from "moment";

export default {
  components: {
    CollapseOfTheOrderFilter,
  },
  data: function () {
    return {
      fields: [
        { key: "number", label: "Venda", class: "text-center" },
        { key: "client_id", label: "Cliente", class: "text-center" },
        { key: "salesman_id", label: "Vendedor", class: "text-center" },
        { key: "ordered_at", label: "Data", class: "text-center" },
        { key: "net_total", label: "Valor", class: "text-center" },
        { key: "profit", label: "Margem", class: this.$acl.isAdmin() ? "text-center" : "d-none" },
        { key: "payment_method", label: "Método  Pgto", class: "text-center", },
        { key: "status", label: "Status", class: "text-center" },
      ],

      value: null,

      salesmans: [],
      ordersData: {
        check: {},
        creditCard: {},
        debtCard: {},
        installment: {},
        money: {},
        orders: {},
        ordersTotal: {},
        profit:{},
        bank_slip:{},
        bank_deposit:{},
        pix:{},
        outers:{},
        digitalWallet:{},
      },
      orders: [],

      searchForm: {
        text: null,
        salesman_id: null,
        saved_at_start: moment().subtract(30, "days").format("YYYY-MM-DD"),
        saved_at_end: moment().format("YYYY-MM-DD"),
        status: ["d", "p", "o", "c"],
        payment_method: ["1", "2", "3", "4", "5",'17','18'],

      },

      status: {
        d: {
          text: "Rascunho",
          class: "badge-secondary",
          value: "0",
        },

        p: {
          text: "Orçamento",
          class: "badge-primary",
        },

        o: {
          text: "Venda",
          class: "badge-success",
        },

        c: {
          text: "Cancelada",
          class: "badge-danger",
        },
      },

      payment_method: {
        1: {
          text: "Dinheiro",
          class: "badge-success",
        },

        2: {
          text: "Cheque",
          class: "badge-success",
        },

        3: {
          text: "C. Credito",
          class: "badge-secondary",
        },
        4: {
          text: "C. Débito",
          class: "badge-secondary",
        },
        5: {
          text: "Crediário",
          class: "badge-secondary",
        },
        15:{
          text:"Boleto Bancário",
          class:"badge-secondary"
        },
        16:{
          text:"Depósito Bancário",
          class:"badge-secondary"
        },
        17: {
          text: "PIX",
          class: "badge-secondary",
        },
        18: {
          text: "Carteira Digital",
          class: "badge-secondary",
        },
        99: {
          text: "Outros",
          class: "badge-secondary",
        },
      },
    };
  },

  created() {
    this.getOrders();
    this.$store.commit("pageHasLoaded");
  },

  computed: {
    date() {
      return moment().format();
    },
  },

  methods: {
    print() {
      window.print();
    },

    getOrders() {
      this.$store.commit("showLoading");
      this.$store
        .dispatch("order/getOrderReport", this.searchForm)
        .then((response) => {
          this.orders = response.data.orders;
          this.ordersData = response.data;
        })
        .catch((error) => {
          this.error = error;
        });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}
hr.color {
  border: 1px solid black;
}
</style>
